/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';

export class Action extends BaseEntity {
  type: ActionType;
  category1: string;
  category2: string;
  category3: string;
  glyph: string;
}

export enum ActionType {
  ALERT = "ALERT",
  DIALOG = "DIALOG",
  DIALOG_CLOSE = "DIALOG_CLOSE",
  EMAIL = "EMAIL",
  EVENT = "EVENT",
  FUNCTION = "FUNCTION",
  PROPERTY = "PROPERTY",
  REST = "REST",
  SMS = "SMS",
  TIMER = "TIMER"
}
